import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { CertificadoEtica, CertificadoEticaList } from 'types/Paperwork';

export async function getCertificateRequests(matricula: number): Promise<CertificadoEtica[]> {
  try {
    const sort = JSON.stringify({
      field: 'created_at',
      dir: -1,
    });

    const url = new URL(`${ config.baseUrl }/matriculates/${ matricula }/ethics?sort=${sort}`);

    type Response = APIResponse<CertificadoEticaList>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      console.error(response.statusText);
      throw new Error('Ocurrió un error al recuperar los pedidos.');
    }

    const content = await response.json() as Response;

    if (content.error || ! content.payload) {
      console.error(content.error);
      throw new Error('Ocurrió un error al recuperar los pedidos.');
    }

    return content.payload.rows;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de recuperar los pedidos.');
  }
}

interface RequestCertificateData {
  matricula: number;
  target: string;
  reason: string;
}

export async function requestCertificate(data: RequestCertificateData): Promise<CertificadoEtica> {
  try {
    const { matricula, ...params } = data;
    const url = new URL(`${ config.baseUrl }/matriculates/${ matricula }/ethics`);

    type Response = APIResponse<CertificadoEtica>

    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
      body: JSON.stringify(params),
    });

    if (response.status !== 200) {
      console.error(response.statusText);
      throw new Error('Ocurrió un error al hacer el pedido.');
    }

    const content = await response.json() as Response;

    if (content.status === 'error' && content.code === 'MATRICULATE_INACTIVE') {
      throw new Error('Su usuario no se encuentra activo para realizar esta operación.');
    }

    if (content.error || ! content.payload) {
      console.error(content.error);
      throw new Error('Ocurrió un error al hacer el pedido.');
    }

    return content.payload;
  } catch (err) {
    throw new Error(
      err?.message ??
      'Ocurrió un problema inesperado al momento de hacer el pedido.',
    );
  }
}
